export const SubModuleNames = {
  greeting: 'Saudação',
  automaticResponses: 'Respostas automáticas',
  members: 'Membros da equipe',
  permissions: 'Permissões',
  attendanceQueues: 'Equipes de atendimento',
  openingHours: 'Horários',
};
